import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import FormFiller from "@/components/FormFiller";
import { GraduationCap, Eye, PenLine } from "lucide-react";

const day = (d) => (d ? new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "");

export function MyTrainingForms() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => { api.get("/me/training-forms").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  useEffect(() => { load(); }, [load]);
  if (!items.length) { return null; }
  return (
    <ul className="mt-4 divide-y divide-slate-100 rounded-xl border border-slate-100" data-testid="my-training-forms">
      {items.map((f) => (
        <li key={f.id} className="flex flex-wrap items-center justify-between gap-3 px-3 py-3" data-testid={`my-training-${f.id}`}>
          <div className="min-w-0">
            <div className="flex items-center gap-2 truncate text-sm font-medium text-slate-800"><GraduationCap className="h-4 w-4 text-indigo-500" />{f.name}</div>
            <div className="mt-0.5 text-xs" data-testid={`my-training-status-${f.id}`}>
              {f.submission ? <span className="text-emerald-700">Signed {day(f.submission.submitted_at)} · locked</span> : <span className="text-amber-700">To complete and sign</span>}
            </div>
          </div>
          <button onClick={() => setOpen(f)} className={`inline-flex h-8 items-center gap-1 rounded-lg px-2.5 text-xs font-medium ${f.submission ? "border border-slate-200 text-slate-700 hover:bg-slate-50" : "bg-indigo-600 text-white hover:bg-indigo-700"}`} data-testid={`my-training-open-${f.id}`}>
            {f.submission ? <><Eye className="h-3.5 w-3.5" />View</> : <><PenLine className="h-3.5 w-3.5" />Complete</>}
          </button>
        </li>
      ))}
      {open && (open.submission
        ? <FormFiller submission={open.submission} locked onClose={() => setOpen(null)} />
        : <FormFiller formId={open.id} formUrl={`/me/training-forms/${open.id}`} submitUrl={`/me/training-forms/${open.id}/submit`} onClose={() => setOpen(null)} onSubmitted={() => { setOpen(null); load(); }} />)}
    </ul>
  );
}
